import type { ReactNode } from "react";
import { noop } from "lodash";
import { Container } from "./Container";
import { ExpandableBlockDataProvider } from "./ExpandableBlockDataProvider";

export interface ExpandableBlockProps {
  children: ReactNode;
  className?: string;
  isDefaultOpen?: boolean;
  isOpen?: boolean;
  onToggle?: () => void;
  shouldCloseOnClickOutside?: boolean;
}

export const ExpandableBlock = ({
  isOpen = false,
  isDefaultOpen = false,
  onToggle = noop,
  shouldCloseOnClickOutside = false,
  className,
  children,
}: ExpandableBlockProps) => (
  <ExpandableBlockDataProvider
    isOpen={isOpen}
    isDefaultOpen={isDefaultOpen}
    onToggle={onToggle}
    shouldCloseOnClickOutside={shouldCloseOnClickOutside}
  >
    <Container className={className}>{children}</Container>
  </ExpandableBlockDataProvider>
);
